<template>
    <header class="header">
        <!-- PC 헤더 -->
        <div class="header-primary-container">
            <div class="header-primary">
                <div class="header-primary__top">
                    <div class="container">
                        <ul>
                            <li><a href="#" target="_blank">e바꿈</a></li>
                            <li><a href="https://edaom.kr/" target="_blank">e다옴</a></li>
                        </ul>
                    </div>
                </div>
                <div class="header-primary__contents">
                    <div class="header-primary__forward">
                        <div class="header-logo">
                            <h1>
                                <router-link to="/" title="홈으로 이동">
                                    <span class="blind">한국전자정보통신산업진흥회</span>
                                </router-link>
                            </h1>
                        </div>
                        <!-- 모바일 사이드바 토글 버튼 -->
                        <div class="mobile-menu">
                            <button type="button" aria-pressed="false" class="button">
                                <span></span>
                            </button>
                        </div>
                    </div>
                    <!-- <div class="header-search">
                        <form class="header-search__form">
                            <input v-model="searchValue" class="header-search__input" type="text" name="" value="" placeholder="검색어를 입력하세요" />
                            <button class="header-search__button" @click="search"></button>
                        </form>
                    </div> -->

                    <div class="header-primary__body">
                        <div class="header-primary__main">
                            <div class="header-primary__main-inner">
                                <ul class="header-menu-lists">
                                    <!--
                                        ※1뎁스 활성화시 a.link에 서브 클래스 추가
                                        서브 클래스명: link--on
                                    -->
                                    <li class="header-menu-list">
                                        <v-menu open-on-hover offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="link" v-on="on" v-bind="attrs">
                                                    <router-link to="/center/notice">
                                                        <h2>이음정보</h2>
                                                    </router-link>
                                                </span>
                                            </template>
                                            <v-list>
                                                <v-list-item to="/center/notice">
                                                    <v-list-item-title class="text-center">공지사항</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item to="/center/reference">
                                                    <v-list-item-title class="text-center">자료실</v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </li>
                                    <li class="header-menu-list">
                                        <router-link to="/counsel/short" class="link"><h2>이음자문</h2></router-link>
                                    </li>
                                    <li class="header-menu-list">
                                        <router-link to="/counsel/long" class="link"><h2>멘토링</h2></router-link>
                                    </li>
                                    <li class="header-menu-list">
                                        <router-link to="/experts/organization" class="link"><h2>전문기업 검색</h2></router-link>
                                    </li>
                                    <li class="header-menu-list">
                                        <router-link to="/experts/individual" class="link"><h2>전문가 검색</h2></router-link>
                                    </li>
                                    <!-- <li class="header-menu-list">
                                        <router-link to="/community/notice" class="link"><h2>커뮤니티</h2></router-link>
                                        <ul class="header-menu-sub">
                                            <li><router-link to="/community/notice" class="sub-link"><span>공지사항</span></router-link></li>
                                            <li><router-link to="/community/reference" class="sub-link"><span>자료실</span></router-link></li>
                                            <li><router-link to="/community/qna" class="sub-link"><span>QnA</span></router-link></li>
                                        </ul>
                                    </li> -->
                                </ul>
                                <div class="header-primary-dimmed"></div>
                            </div>
                        </div>
                    </div>

                    <div class="header-primary__right">
                        <!-- <div class="header-primary__global">
                            <i class="icon icon-language"></i><locale-select></locale-select>
                        </div> -->
                        <gnb-login-button class="header-customer-lists" />
                        <!-- <router-link to="/estimate/estimate-inquiry" class="header-primary__right-inquiry"><span class="blind">견적신청 1566-7777</span></router-link> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- // PC 헤더 -->

        <!-- Mobile 헤더 -->
        <div class="mobile-sidebar">
            <div class="mobile-sidebar__head">
                <button class="mobile-sidebar__close" type="button"><span class="blind">모바일 메뉴바 닫기</span></button>
                <!-- <div class="mobile-sidebar-info">
                    <router-link class="member-name" to="/login">
                        <span>로그인 해주세요</span>
                        <span></span>
                    </router-link>
                </div> -->
                <!-- <div class="mobile-sidebar__global">
                    <i class="icon icon-language"></i><locale-select></locale-select>
                </div> -->
            </div>
            <div class="mobile-sidebar__link">
                <gnb-login-button class="mobile-gnb-link" />
            </div>
            <div class="mobile-sidebar__body">
                <ul class="mobile-category__lists">
                    <li class="mobile-category__list" data-category-order>
                        <div class="mobile-category__list-link" data-toggle="closed">
                            <span>이음정보</span><div class="arrow"></div>
                        </div>
                        <ul class="mobile-category__level">
                            <li><router-link to="/center/notice" class="mobile-category__level-link"><span>공지사항</span></router-link></li>
                            <li><router-link to="/center/reference" class="mobile-category__level-link"><span>자료실</span></router-link></li>
                            <!-- <li><router-link to="/community/qna" class="mobile-category__level-link"><span>QnA</span></router-link></li> -->
                        </ul>
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <router-link to="/counsel/short" class="mobile-category__list-link"><span>이음자문</span></router-link>
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <router-link to="/counsel/long" class="mobile-category__list-link"><span>멘토링</span></router-link>
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <router-link to="/experts/organization" class="mobile-category__list-link"><span>전문기업 검색</span></router-link>
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <router-link to="/experts/individual" class="mobile-category__list-link"><span>전문가 검색</span></router-link>
                    </li>
                    <!-- <li class="mobile-category__list" data-category-order>
                        <div class="mobile-category__list-link" data-toggle="closed">
                            <span>커뮤니티</span><div class="arrow"></div>
                        </div>
                        <ul class="mobile-category__level">
                            <li><router-link to="/community/notice" class="mobile-category__level-link"><span>공지사항</span></router-link></li>
                            <li><router-link to="/community/reference" class="mobile-category__level-link"><span>자료실</span></router-link></li>
                            <li><router-link to="/community/qna" class="mobile-category__level-link"><span>QnA</span></router-link></li>
                        </ul>
                    </li> -->
                </ul>
                <!-- <ul class="mobile-usermenu__lists">
                    <li class="mobile-usermenu__list"><router-link to="/center/notice" class="mobile-usermenu__list-link"><span>공지사항</span></router-link></li>
                    <li class="mobile-usermenu__list"><router-link to="/center/notice" class="mobile-usermenu__list-link"><span>공지사항</span></router-link></li>
                </ul> -->
            </div>
            <!-- <div class="mobile-sidebar__foot">
                <gnb-login-button class="mobile-foot-link" />
            </div> -->
        </div>
        <div class="mobile-sidebar-dimmed"></div>
        <!-- // Mobile 헤더 -->
    </header>
</template>

<script>
import api from "@/api";
import { Header } from "@/plugins/header.js"; // Sticky & Heaer 스크립트
import gnbLoginButton from "@/components/client/login/gnb-login-button.vue";
import LocaleSelect from "@/components/client/inc/locale-select.vue";

export default {
    components: {
        gnbLoginButton,
        LocaleSelect,
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
    },
    methods: {
        header: function() {
            this.$nextTick(function() {
                Header(); // Sticky & Heaer 스크립트 로드
            });
        },
    },
    mounted() {
        this.header();
        window.scrollTo(0, 0); // 라우터 이동 시 스크롤 상단부터 시작
    },
    watch: {
        accessToken() {
            if (!this.accessToken) {
                alert("로그아웃 되었습니다");
                this.$router.push("/");
            }
        },
    },
};
</script>
